import { CtaButton, Grid } from '@zappyrent/hundop';
import {
  Trans,
  I18nextContext,
  useTranslation,
} from 'gatsby-plugin-react-i18next';
import { toUpper } from 'lodash';
import React, { useContext } from 'react';

import useUtmQueryString from '../../../hooks/useUtmQueryString';
import {
  StyledCtaButtonWrapper,
  StyledNote,
  StyledParagraph,
} from './ReferALandlordIntro.styles';

const ReferALandlordIntroText = (): JSX.Element => {
  const { language } = useContext(I18nextContext);
  const { t } = useTranslation('product');
  const utmQueryString = useUtmQueryString('referral');

  return (
    <Grid container>
      <StyledParagraph>
        <Trans i18nKey="referALandlordIntroText1" t={t} />
      </StyledParagraph>
      <StyledParagraph>
        <Trans i18nKey="referALandlordIntroText2" t={t} />
      </StyledParagraph>
      <StyledNote>{t('referALandlordIntroNote')}</StyledNote>
      <StyledCtaButtonWrapper>
        <CtaButton
          href={`${process.env.GATSBY_REFERRAL_PROGRAM_URL}/${language}?${utmQueryString}`}
          tag="a"
          title={t('inviteALandlord')}
          user="landlord"
          width="100%"
        >
          {toUpper(t('inviteALandlord'))}
        </CtaButton>
      </StyledCtaButtonWrapper>
    </Grid>
  );
};

export default ReferALandlordIntroText;
